import React from "react";
import { IBenefitsMemberFromData } from "../../exports/interfaces";

const BenefitsMemberFrom = (props: {
  benefitsMemberData: IBenefitsMemberFromData[];
}) => {
  return (
    <section className="quality-work" style={{ padding: "90px 0 90px" }}>
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            <div className="quality-work__tab-box tabs-box">
              <div className="donation-details__presentation">
                <div className="donation-details__presentation-icon-box">
                  {/* <span className="icon-pdf"></span> */}
                  <div>
                    <h4 className="section-title__title">
                      {props?.benefitsMemberData[0]?.title}
                    </h4>
                    <p style={{ textAlign: "justify", marginTop: "1rem" }}>
                      {props?.benefitsMemberData[0]?.description}
                    </p>
                  </div>
                </div>
                <div
                  className="donation-details__presentation-btn-box"
                  style={{ whiteSpace: "nowrap" }}
                >
                  <a
                    href={`${process.env.REACT_APP_cmsUrl}${props?.benefitsMemberData[0]?.file[0]?.media?.url}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="thm-btn donation-details__presentation-btn"
                  >
                    Download the form
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsMemberFrom;
